import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useListings = (category) =>
  useQuery({
    queryKey: ["listings", category],
    queryFn: async () => {
      const res = await api.get(`/listings${category ? `?category=${category}` : ""}`);
      return res.data;
    },
  });
